import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { DocumentCheckIdDto } from '@/modules/document/dto/document-check-id.dto.ts';
import type { DocumentCheckId } from '@/modules/document/types/document-check-id.type.ts';

export class DocumentCheckIdAdapter {
  private static map(response: DocumentCheckIdDto): DocumentCheckId {
    return {
      id: response.DOC_ID,
      type: response.Тип,
      content: response.Содержание,
      isAvailable: !!response.Доступен,
      isFound: !!response.Найдено,
    };
  }

  static mapList(response: ItemsDto<DocumentCheckIdDto>) {
    return response.items.map(DocumentCheckIdAdapter.map);
  }
}
